import "../../../blocks/accordian/accordian-frontend";
import "../../../blocks/popup/popup-init";
import "../block-etension/section-divider-init";
import "../../../blocks/animated-button/animated-button";
document
  .querySelectorAll('.wpcf7-checkbox input[type="checkbox"]')
  .forEach(function (cb) {
    cb.addEventListener("change", function () {
      var lbl = this.closest("label");
      if (this.checked) {
        lbl.style.background = "#1a1a1a";
        lbl.style.borderColor = "#1a1a1a";
        lbl.style.color = "#fff";
      } else {
        lbl.style.background = "";
        lbl.style.borderColor = "";
        lbl.style.color = "";
      }
    });
  });
